import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    url: String,
    companySelector: String
  };
  static targets = ["select"];

  connect() {
    this.companyElement = document.querySelector(this.companySelectorValue);
    if (!this.companyElement) return;

    this.boundHandler = this.handleCompanyChange.bind(this);
    this.companyElement.addEventListener('change', this.boundHandler);
  }

  disconnect() {
    if (this.companyElement && this.boundHandler) {
      this.companyElement.removeEventListener('change', this.boundHandler);
    }
  }

  async handleCompanyChange() {
    const companyId = this.currentCompanyId();
    if (!companyId) {
      this.replaceOptions([]);
      return;
    }

    try {
      const response = await fetch(`${this.urlValue}?company_id=${encodeURIComponent(companyId)}`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) return;
      const data = await response.json();
      this.replaceOptions(data.users || []);
    } catch (e) {
      // network error: leave current options untouched
    }
  }

  currentCompanyId() {
    const input = document.querySelector('input[name="ticket[company_id]"]');
    return input ? input.value : '';
  }

  replaceOptions(users) {
    const $select = $(this.selectTarget);
    const currentSelected = ($select.val() || []).map(String);
    $select.empty();
    users.forEach((user) => {
      const id = String(user.id);
      const opt = new Option(user.name, id, false, currentSelected.includes(id));
      $select.append(opt);
    });
    $select.trigger('change');
  }
}
